import React from "react";
import { twMerge } from "tailwind-merge";
import { theme } from "./index";

interface VulnerabilitiesProps {
  className?: string;
}

export const Vulnerabilities: React.FC<VulnerabilitiesProps> = ({
  className,
}) => (
  <svg
    width="19"
    height="22"
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(
      theme,
      className,
    )}
  >
    <path d="M18.05 5.64062H14.88C14.3723 4.76069 13.6729 4.00484 12.8268 3.4295L14.6656 1.59066L13.075 0L10.6269 2.44803C10.108 2.32394 9.57778 2.25625 9.025 2.25625C8.47222 2.25625 7.942 2.32394 7.43434 2.44803L4.97503 0L3.38437 1.59066L5.21194 3.4295C4.37712 4.00484 3.67769 4.76069 3.17003 5.64062H0V7.89687H2.35778C2.30138 8.26916 2.25625 8.64144 2.25625 9.025V10.1531H0V12.4094H2.25625V13.5375C2.25625 13.9211 2.30138 14.2933 2.35778 14.6656H0V16.9219H3.17003C4.34328 18.9412 6.52056 20.3062 9.025 20.3062C11.5294 20.3062 13.7067 18.9412 14.88 16.9219H18.05V14.6656H15.6922C15.7486 14.2933 15.7937 13.9211 15.7937 13.5375V12.4094H18.05V10.1531H15.7937V9.025C15.7937 8.64144 15.7486 8.26916 15.6922 7.89687H18.05V5.64062ZM11.2812 14.6656H6.76875V12.4094H11.2812V14.6656ZM11.2812 10.1531H6.76875V7.89687H11.2812V10.1531Z" />
  </svg>
);
